import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e433bf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Front page guide", -1))
const _hoisted_3 = {
  key: 0,
  class: "alert alert-warning text-center",
  style: {"margin-top":"10px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "Maintenance flags", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mt-1 mb-2" }, "No items found", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, null, -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "flag" }, "Flag"),
    /*#__PURE__*/_createElementVNode("th", { class: "colour" }, "Colour"),
    /*#__PURE__*/_createElementVNode("th", { class: "backgroundcolour" }, "Background Colour"),
    /*#__PURE__*/_createElementVNode("th", { class: "icon" }, "Icon"),
    /*#__PURE__*/_createElementVNode("th", { class: "description" }, "Description"),
    /*#__PURE__*/_createElementVNode("th", { class: "pdfdisplay" }, "PDF Display"),
    /*#__PURE__*/_createElementVNode("th", { class: "delete" })
  ])
], -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]

import { ref, computed, inject } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { CustomerDictionary } from '@/models/customerdictionary.model';
import { Maintenanceflag } from '@/models';
import MaintenanceflagModal from '@/components/modals/MaintenanceflagModal.vue';
import TiptapEditor from '@/components/editor/TiptapEditor.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Maintenanceflags',
  setup(__props) {

const store = useStore();
const toasted = useToast();

const actProperty: any = inject('actProperty');

const customerdictionary = computed(() => store.getters['customerdictionary/current'] as CustomerDictionary);
const maintenanceflags = computed(() => store.getters['customerdictionary/maintenanceflags'] as Maintenanceflag[]);

const frontpageguide = computed({
  get: () => customerdictionary.value.report_configuration.frontpageguide,
  set: (value: string) => {
    setCustomerDictionaryDeep({
      path: "report_configuration.frontpageguide",
      data: value,
    });
  }
});

const setCustomerDictionaryDeep = async (payload: { path: string; data: any }) => {
  await store.dispatch('customerdictionary/setCustomerDictionaryDeep', payload);
};

const removeFromMaintenanceflags = (flag: Maintenanceflag) => {
  store.commit('customerdictionary/removeFromMaintenanceflags', flag);
};

const maintenanceFlagModalEdit = ref(null);

const setSelectedMaintenanceflag = (flag: Maintenanceflag) => {
  store.commit('customerdictionary/setSelectedMaintenanceflag', flag);
};

const updateFrontpageguide = (value: string) => {
  setCustomerDictionaryDeep({
    path: "report_configuration.frontpageguide",
    data: value,
  });
};

const edit = (flag: Maintenanceflag) => {
  setSelectedMaintenanceflag(flag);
  const modal = maintenanceFlagModalEdit.value;
  modal.show();
};

const remove = async (flag: Maintenanceflag) => {
  actProperty
    .confirmPrompt()
    .then(() => removeFromMaintenanceflags(flag))
    .then(() => toasted.success("Flag deleted"))
    .catch((err: any) => actProperty.displayError(err));
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      (_openBlock(), _createBlock(TiptapEditor, {
        content: frontpageguide.value,
        key: customerdictionary.value.company_name,
        onBlur: _cache[0] || (_cache[0] = ($event: any) => (updateFrontpageguide($event)))
      }, null, 8, ["content"]))
    ]),
    (!maintenanceflags.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7))
      : (_openBlock(), _createElementBlock("table", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(maintenanceflags.value, (flag) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: flag.slug
              }, [
                _createElementVNode("td", null, _toDisplayString(flag.flag), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("i", {
                    class: "fas fa-circle fa-lg",
                    style: _normalizeStyle({ color: flag.colour })
                  }, null, 4)
                ]),
                _createElementVNode("td", null, [
                  (flag.backgroundcolour)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "fas fa-circle fa-lg",
                        style: _normalizeStyle({ color: flag.backgroundcolour })
                      }, null, 4))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  (flag.symbol)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([flag.symbol, "flag-icon"])
                      }, null, 2))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, _toDisplayString(flag.description), 1),
                _createElementVNode("td", null, _toDisplayString(flag.pdfDisplay), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-danger",
                    onClick: [
                      ($event: any) => (remove(flag)),
                      _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                    ]
                  }, _hoisted_12, 8, _hoisted_10),
                  _createElementVNode("button", {
                    class: "btn btn-outline-primary",
                    onClick: [
                      ($event: any) => (edit(flag)),
                      _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                    ]
                  }, _hoisted_15, 8, _hoisted_13)
                ])
              ]))
            }), 128))
          ])
        ])),
    _createVNode(MaintenanceflagModal, {
      id: `maintenance-flag-modal-edit`,
      ref_key: "maintenanceFlagModalEdit",
      ref: maintenanceFlagModalEdit,
      operation: 'edit'
    }, null, 512)
  ]))
}
}

})